import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { GetWishlistQueryDto } from './api.dto';
import { WishlistType } from '../types/wishlistShema';

export const deleteWishlist = createAsyncThunk<WishlistType, GetWishlistQueryDto>(
  'wishlist/deleteWishlist',
  async ({ productId, regionId }) => {
    return await MyAxios.delete(`/api/wishlist/delete-product?productId=${productId}&regionId=${regionId}`)
      .then(handleResponse)
      .catch(handleError);
  },
);
